import {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import type { Locale } from "@mongmee/contracts";

const messages = {
  "lo-LA": {
    appName: "Mongmee Automation",
    research: "ຄົ້ນຄວ້າ",
    channels: "ຊ່ອງທາງ",
    login: "ເຂົ້າລະບົບ",
    email: "ອີເມວ",
    password: "ລະຫັດຜ່ານ",
    logout: "ອອກຈາກລະບົບ",
    dashboard: "ພາບລວມ",
    onboarding: "ຕັ້ງຄ່າທຸລະກິດ",
    automationSettings: "ຕັ້ງຄ່າການໂພສ",
    brands: "ແບຣນ",
    team: "ທີມ",
    audit: "ປະຫວັດການ",
    content: "ເນື້ອຫາ",
    approvals: "ການອະນຸມັດ",
    calendar: "ປະຕິທິນ",
    contentHistory: "ປະຫວັດເນື້ອຫາ",
    platform: "ຈັດການແພລດຟອມ",
    activeBrands: "ແບຣນທີ່ໃຊ້ງານ",
    teamMembers: "ສະມາຊິກທີມ",
    recentActivity: "ກິດຈະກຳຫຼ້າສຸດ",
    createBrand: "ສ້າງແບຣນ",
    createTenant: "ສ້າງລູກຄ້າ",
    name: "ຊື່",
    slug: "ລະຫັດ URL",
    locale: "ພາສາ",
    timezone: "ເຂດເວລາ",
    ownerEmail: "ອີເມວຜູ້ເປັນເຈົ້າຂອງ",
    ownerName: "ຊື່ຜູ້ເປັນເຈົ້າຂອງ",
    save: "ບັນທຶກ",
    loading: "ກຳລັງໂຫຼດ…",
    noData: "ຍັງບໍ່ມີຂໍ້ມູນ",
    activation: "ເປີດໃຊ້ບັນຊີ",
    confirmPassword: "ຢືນຢັນລະຫັດຜ່ານ",
    activate: "ເປີດໃຊ້",
    copyActivation: "ສຳເນົາລິ້ງເປີດໃຊ້",
    tenant: "ລູກຄ້າ",
    requestFailed: "ບໍ່ສາມາດດຳເນີນການໄດ້",
    serviceUnavailable: "ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບໄດ້",
    retry: "ລອງໃໝ່",
    createBrief: "ສ້າງໂຈດເນື້ອຫາ",
    contentTitle: "ຫົວຂໍ້ເນື້ອຫາ",
    brand: "ແບຣນ",
    objective: "ເປົ້າໝາຍ",
    instructions: "ຂໍ້ກຳນົດ",
    create: "ສ້າງ",
    open: "ເປີດ",
    status: "ສະຖານະ",
    editor: "ຕົວແກ້ໄຂ",
    sources: "ແຫຼ່ງຂໍ້ມູນ",
    addSource: "ເພີ່ມແຫຼ່ງຂໍ້ມູນ",
    sourceTitle: "ຊື່ແຫຼ່ງຂໍ້ມູນ",
    sourceUrl: "ລິ້ງແຫຼ່ງຂໍ້ມູນ",
    publisher: "ຜູ້ເຜີຍແຜ່",
    trustLevel: "ລະດັບຄວາມເຊື່ອຖື",
    relevance: "ຄວາມກ່ຽວຂ້ອງ",
    headline: "ຫົວຂໍ້",
    body: "ເນື້ອຄວາມ",
    hashtags: "ແຮັດແທັກ",
    revisionNote: "ໝາຍເຫດສະບັບ",
    saveRevision: "ບັນທຶກສະບັບໃໝ່",
    submitReview: "ສົ່ງກວດ",
    revisions: "ສະບັບເນື້ອຫາ",
    approve: "ອະນຸມັດ",
    reject: "ສົ່ງກັບແກ້ໄຂ",
    comment: "ຄຳເຫັນ",
    schedule: "ກຳນົດເວລາ",
    scheduleFor: "ເວລາທີ່ກຳນົດ",
    cancelSchedule: "ຍົກເລີກກຳນົດເວລາ",
    noRevision: "ຍັງບໍ່ມີສະບັບເນື້ອຫາ",
    contentOperations: "ຈັດການເນື້ອຫາ",
    contentInbox: "ກ່ອງຮັບເນື້ອຫາ",
    humanApprovalGate: "ການກວດອະນຸມັດໂດຍຄົນ",
    publishingReadiness: "ຄວາມພ້ອມກ່ອນເຜີຍແຜ່",
    contentAuditTrail: "ປະຫວັດກວດສອບເນື້ອຫາ",
    actor: "ຜູ້ດຳເນີນການ",
    trustPrimary: "ແຫຼ່ງຂໍ້ມູນຕົ້ນສະບັບ",
    trustTrusted: "ເຊື່ອຖືໄດ້",
    trustRestricted: "ຈຳກັດການນຳໃຊ້",
  },
  "th-TH": {
    appName: "Mongmee Automation",
    research: "ค้นคว้า",
    channels: "ช่องทาง",
    login: "เข้าสู่ระบบ",
    email: "อีเมล",
    password: "รหัสผ่าน",
    logout: "ออกจากระบบ",
    dashboard: "ภาพรวม",
    onboarding: "ตั้งค่าธุรกิจ",
    automationSettings: "ตั้งค่าการโพสต์",
    brands: "แบรนด์",
    team: "ทีม",
    audit: "ประวัติการทำงาน",
    content: "เนื้อหา",
    approvals: "การอนุมัติ",
    calendar: "ปฏิทิน",
    contentHistory: "ประวัติเนื้อหา",
    platform: "จัดการแพลตฟอร์ม",
    activeBrands: "แบรนด์ที่ใช้งาน",
    teamMembers: "สมาชิกทีม",
    recentActivity: "กิจกรรมล่าสุด",
    createBrand: "สร้างแบรนด์",
    createTenant: "สร้างลูกค้า",
    name: "ชื่อ",
    slug: "รหัส URL",
    locale: "ภาษา",
    timezone: "เขตเวลา",
    ownerEmail: "อีเมลเจ้าของ",
    ownerName: "ชื่อเจ้าของ",
    save: "บันทึก",
    loading: "กำลังโหลด…",
    noData: "ยังไม่มีข้อมูล",
    activation: "เปิดใช้งานบัญชี",
    confirmPassword: "ยืนยันรหัสผ่าน",
    activate: "เปิดใช้งาน",
    copyActivation: "คัดลอกลิงก์เปิดใช้งาน",
    tenant: "ลูกค้า",
    requestFailed: "ไม่สามารถดำเนินการได้",
    serviceUnavailable: "ไม่สามารถเชื่อมต่อระบบได้",
    retry: "ลองใหม่",
    createBrief: "สร้างโจทย์เนื้อหา",
    contentTitle: "หัวข้อเนื้อหา",
    brand: "แบรนด์",
    objective: "เป้าหมาย",
    instructions: "ข้อกำหนด",
    create: "สร้าง",
    open: "เปิด",
    status: "สถานะ",
    editor: "ตัวแก้ไข",
    sources: "แหล่งข้อมูล",
    addSource: "เพิ่มแหล่งข้อมูล",
    sourceTitle: "ชื่อแหล่งข้อมูล",
    sourceUrl: "ลิงก์แหล่งข้อมูล",
    publisher: "ผู้เผยแพร่",
    trustLevel: "ระดับความน่าเชื่อถือ",
    relevance: "ความเกี่ยวข้อง",
    headline: "พาดหัว",
    body: "เนื้อความ",
    hashtags: "แฮชแท็ก",
    revisionNote: "หมายเหตุฉบับ",
    saveRevision: "บันทึกฉบับใหม่",
    submitReview: "ส่งตรวจ",
    revisions: "ฉบับเนื้อหา",
    approve: "อนุมัติ",
    reject: "ส่งกลับแก้ไข",
    comment: "ความคิดเห็น",
    schedule: "กำหนดเวลา",
    scheduleFor: "เวลาที่กำหนด",
    cancelSchedule: "ยกเลิกกำหนดเวลา",
    noRevision: "ยังไม่มีฉบับเนื้อหา",
    contentOperations: "จัดการเนื้อหา",
    contentInbox: "กล่องรับเนื้อหา",
    humanApprovalGate: "การตรวจอนุมัติโดยบุคคล",
    publishingReadiness: "ความพร้อมก่อนเผยแพร่",
    contentAuditTrail: "ประวัติตรวจสอบเนื้อหา",
    actor: "ผู้ดำเนินการ",
    trustPrimary: "แหล่งข้อมูลต้นฉบับ",
    trustTrusted: "เชื่อถือได้",
    trustRestricted: "จำกัดการใช้งาน",
  },
} as const;

type MessageKey = keyof (typeof messages)["lo-LA"];

interface LocaleContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: MessageKey) => string;
  formatDate: (value: string | Date) => string;
}

const LocaleContext = createContext<LocaleContextValue | null>(null);

export function LocaleProvider({ children }: PropsWithChildren) {
  const [locale, setLocaleState] = useState<Locale>(() => {
    const stored = window.localStorage.getItem("mongmee-locale");
    return stored === "th-TH" ? "th-TH" : "lo-LA";
  });

  useEffect(() => {
    document.documentElement.lang = locale === "lo-LA" ? "lo" : "th";
  }, [locale]);

  const value = useMemo<LocaleContextValue>(
    () => ({
      locale,
      setLocale(nextLocale) {
        setLocaleState(nextLocale);
        window.localStorage.setItem("mongmee-locale", nextLocale);
      },
      t(key) {
        return messages[locale][key];
      },
      formatDate(value) {
        return new Intl.DateTimeFormat(locale, {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(new Date(value));
      },
    }),
    [locale],
  );
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);
  if (!context) throw new Error("useLocale must be used inside LocaleProvider");
  return context;
}
